<template>
  <div>
    <v-toolbar dense dark color="primary">
      <v-toolbar-title class="text-center" style="font-size: 0.95rem !important;">  Тарифный калькулятор электроэнергии<br>для юридических лиц
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card style="margin-top: 8px;" flat>
    <v-list dense >
      <v-list-item>
        <v-menu
            ref="menu"
            v-model="dmenu"
            :close-on-content-click="true"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="picker"
                density="comfortable"
                label="Выберите месяц и год"
                prepend-icon="mdi-calendar"
                readonly
                dense
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              class="iwidget"
              v-model="picker"
              :max="getEndDate"
              color="primary"
              dense
              full-width
              locale="ru"
              min="2021-01-01"
              next-icon="mdi-skip-next"

              prev-icon="mdi-skip-previous"
              type="month"
              width=""
              year-icon="mdi-calendar-blank"
              @change="updateChecking"
          >

          </v-date-picker>
        </v-menu>
      </v-list-item>
      <v-list-item>
        <v-autocomplete v-model="region_id" :items="regions" dense density="comfortable" item-text="label"
                        item-value="value" label="Субъект РФ" variant="outlined"
        >
        </v-autocomplete>
      </v-list-item>
      <v-list-item v-if="region_id && zones[1]">
        <v-select v-model="zone_id" :items="zones" dense density="comfortable" item-text="label"
                  item-value="value" label="Зона деятельности " variant="outlined"
        >
        </v-select>
      </v-list-item>
      <v-list-item>
        <v-select v-model="tr" :items="trs" dense density="comfortable" item-text="label"
                  item-value="value" label="Услуга по передаче " variant="outlined"
        >
        </v-select>
      </v-list-item>
      <v-list-item>
        <v-row>
          <v-col>
            <v-select v-model="category" :items="categories" dense density="comfortable" item-text="label"
                      item-value="value" label="Макс. мощность" variant="outlined"
            >
            </v-select>
          </v-col>
          <v-col>
            <v-select small v-model="voltage_level" :items="voltage_levels" dense density="comfortable" item-text="label"
                      item-value="level" label="Уровень напряжения " variant="outlined"
            >
            </v-select>
          </v-col>
        </v-row>

      </v-list-item>

      </v-list>
      <v-card-actions app>
        <v-row>
          <v-col>
            <v-btn
                v-if="zone_id"
                block
                small
                color="primary"
                @click="toPrices()"
            >
              Показать цены
            </v-btn>
            <v-btn
                v-if="!zone_id"
                block
                small
                disabled
                color="primary"
                @click="toPrices()"
            >
              Цены и тарифы
            </v-btn>
          </v-col>
          <v-col>      <v-btn
              v-if="!result"
              block
              small
              color="primary"
              @click="toCalculate()"
          >
            Рассчитать
          </v-btn></v-col>

        </v-row>
      </v-card-actions>
      <v-footer app>
        <img  style="height: 12px; cursor: pointer;" src="../assets/e2b_logo.png"><v-space></v-space>
        <a  style="margin-left: 12px">etarif.ru</a>
      </v-footer>
    </v-card>

  </div>

</template>

<script>
import router from './../router/index.js'
//import Handsontable from "handsontable";
//import "handsontable/dist/handsontable.full.css";
import axios from 'axios';
//import Bars from 'vuebars'
import * as XLSX from 'xlsx'
//import VolumeModal from './Volume.vue'


export default {
  name: 'IframeWidget',
  props: ['isMobile'],
  components: {
    //  VolumeModal,
  },

  data: () => ({
    know: true,
    tr:'mrsk',
    trs:[  {
      value: 'fsk',
      label: 'ФСК'
    }],
    sh: true,
    file: null,
    results: {
      total_value: {
        ck1: 1,
        ck3: 2,
        ck4: 3,
      },
      electric: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
      power: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
      transfer_service1: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
      transfer_service2: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
      sn_gp: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
      org_cost: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
      price: {
        ck1: null,
        ck3: null,
        ck4: null,
      },
    },
    power: '',
    dmenu:false,
    showVolume: true,
    nowDate: new Date().toISOString().slice(0, 10),
    date: new Date(),
    countries: ['RU'],
    contactForm: {
      type: 'Потребитель',
      fio: '',
      region: 'Москва',
      phone: '',
    },
    roles: ['Генератор', 'Потребитель'],
    e6: 1,
    vol: {
      volume: '',
      arr: [],
      newarr: [],
      sum: 0,
    },
    mv: 'kvt',
    drawer: true,
    consuption: 0,
    dkp: {
      ck1: null,
      ck3: null,
      ck4: null
    },
    checking: false,
    dialog: false,
    picker: new Date().toISOString().substr(0, 7),
    calculating: false,
    haveVolume: true,
    client_type: null,
    regions: [],
    zone_id: null,
    step1Ability: false,
    region_id: null,
    zones: [],
    zone: null,
    voltage_level: 'nn',
    category: 1,
    price_category: 1,
    hasEP: false,
    integral_volume: null,
    volume_file: undefined,
    result: false,
    visitor_id: 0,
    cf: true,
    calculated: {
      ck1: {
        total: '-',
        tarif: '-'
      },
      ck2: {
        total: '-',
        tarif: '-'
      },
      ck3: {
        total: '-',
        tarif: '-'
      },
      ck4: {
        total: '-',
        tarif: '-'
      },
    },
    contract_type: "dkp",
    contract_types: [{
      type: "dkp",
      label: "Договор Купли-Продажи"
    }, {
      type: "des",
      label: "Договор ЭнергоСнабжения"
    }],
    consumption_type: null,
    voltage_levels: [{
      level: 'vn',
      label: 'ВН'
    }, {
      level: 'sn1',
      label: 'СН-1'
    }, {
      level: 'sn2',
      label: 'СН-2'
    }, {
      level: 'nn',
      label: 'НН'
    },],
    categories: [
      {
        value: 1,
        label: 'менее 670 кВт'
      },
      {
        value: 2,
        label: 'более 670 кВт, менее 10 МВт'
      },
      {
        value: 3,
        label: 'более 10 МВт'
      },
    ],
    price_categories: [
      {
        value: 1,
        label: '1-ая категория'
      },
      {
        value: 2,
        label: '2-ая категория'
      },
      {
        value: 3,
        label: '3-яя категория'
      },
      {
        value: 4,
        label: '4-ая категория'
      },
    ],

    consumption_types: [
      {
        type: 1,
        name: '247',
      },
      {
        type: 2,
        name: 'Ночное',
      },
      {
        type: 3,
        name: 'Дневное',
      },
    ],
    client_types: [
      {
        type: 1,
        name: 'АЗС',
      },
      {
        type: 2,
        name: 'Магазин',
      },
      {
        type: 3,
        name: 'Сотовая вышка',
      },
      {
        type: '',
        name: '....',
      },
    ],
    months: [
      {
        name: 'Январь',
        value: 1,
      },
      {
        name: 'Февраль',
        value: 2,
      }, {
        name: 'Март',
        value: 3,
      }, {
        name: 'Апрель',
        value: 4,
      }, {
        name: 'Май',
        value: 5,
      }, {
        name: 'Июнь',
        value: 6,
      }, {
        name: 'Июль',
        value: 7,
      }, {
        name: 'Август',
        value: 8,
      }, {
        name: 'Сентябрь',
        value: 9,
      }, {
        name: 'Октябрь',
        value: 10,
      }, {
        name: 'Ноябрь',
        value: 11,
      }, {
        name: 'Декабрь',
        value: 12,
      },
    ],

  }),
  watch: {
    $route(to, from) {
      console.log('to', to);
      console.log('from', from);
      if (from.name == 'result') {
        this.result = false;
      }

    },
    region_id: {
      handler(val) {
        this.getZones(val);
      }
    },
    zone_id: {
      handler() {

        this.sendToCheck();
      }
    }
  },
  methods: {
    toPrices(){
      window.open(this.selfDomain+'?zone_id='+this.zone_id+'&picker='+this.picker+'&redirect_type=prices'+'&region_id='+this.region_id+'&month='+this.month+'&year='+this.year+'&voltage_level='+this.voltage_level+'&category='+this.category+'&tr='+this.tr, '_blank').focus();
    },
    toCalculate(){
      window.open(this.selfDomain+'?zone_id='+this.zone_id+'&picker='+this.picker+'&redirect_type=calculation'+'&region_id='+this.region_id+'&month='+this.month+'&year='+this.year+'&voltage_level='+this.voltage_level+'&category='+this.category+'&tr='+this.tr, '_blank').focus();
    },
    metrikaTarget(target) {
      this.$metrika.reachGoal(target)
    },
    toVk() {
      this.metrikaTarget('toVk');
      window.open('https://vk.com/club217230014', '_blank').focus();
    },
    toTg() {
      this.metrikaTarget('toTg');
      window.open('https://t.me/etarif', '_blank').focus();
    },
    getCustomMonth(month) {
      let i = new Date(month).getMonth(month);
      return this.months[i].name;
    },
    backToVolume() {
      this.result = false;
      router.push('/');
    },
    updateChecking() {
      this.generateEmpty();
      this.sendToCheck();
    },
    selectFile() {
      this.metrikaTarget('loadfile');
      let fileInputElement = this.$refs.file;
      fileInputElement.click();
    },
    getFromBuffer() {
      this.metrikaTarget('target');
      navigator.clipboard.readText()
          .then(text => {
            this.vol.volume = text;
            //   console.log('fromBuffer',this.vol.volume);
            this.convert();
          })
          .catch(err => {
            console.error('Failed to read clipboard contents: ', err);
          });

    },
    generateEmpty() {
      this.vol.arr = [];
      var dayscount = this.getDaysCount(this.year, this.month);
      var obj = {
        value: 0,
        color: '#fff',
      }
      for (var i = 0; i < dayscount; i++) {
        this.vol.arr[i] = [];
        for (var j = 0; j < 24; j++) {
          this.vol.arr[i][j] = obj;
        }
      }

    },
    sendStatistic() {
      var referrer = '';
      if (document.referrer) {
        referrer = document.referrer;
      }
      axios.get(this.host + '/updatestatistic?spa_referer=' + referrer).then((response) => {
        this.visitor_id = response.data;
      });
    },
    sendToCheck() {
      this.checking = true;
      var req = {
        value: this.vol.arr,
        month: this.month,
        year: this.year,
        zone: this.zone_id
      };
      axios.post(this.host + '/check', req).then((response) => {
        this.vol.arr = response.data.volume;
        this.power = response.data.power;
        this.checking = false;
      })
          .catch((error) => {
            console.log(error);
            this.checking = false;
            this.$toast.error('Ошибка отправки на сервер', {})

          })
    },
    toRound(val) {
      var result = Math.round(val * 100) / 100;
      return result.toLocaleString('ru');
    },
    toRoundPower(val) {
      var result = Math.round(val * 100000) / 100000;
      return result;
    },
    pasteConvert() {
      setTimeout(() => {
        this.convert();
      }, 100);
    },
    monthsTrim() {
      //  console.log('vol.lenght',this.vol.arr.length);
      var days_count = this.getDaysCount(this.year, this.month);
      //  console.log('days_count',days_count);
      if (this.vol.arr.length > days_count) {
        //  alert('!!!!!');
        //  console.log('wewewew',this.vol.arr.length - days_count);
        this.vol.arr.splice(days_count, this.vol.arr.length - days_count);
      }

      console.log('volarr', this.vol.arr);
      this.$forceUpdate();

    },

    calculate() {
      var sum = 0;
      var arr = [];
      for (let i = 0; i < this.vol.arr.length; i++) {
        var sarr = this.vol.arr[i];
        arr[i] = [];
        for (let j = 0; j < sarr.length; j++) {
          if (this.mv == 'kvt') {
            arr[i][j] = sarr[j];
          } else {
            arr[i][j] = sarr[j];
          }
          sum = sum + arr[i][j]['value'];
        }
      }

      this.obj = {
        month: this.month,
        year: this.year,
        volume: JSON.stringify(arr),
        sum: sum,
        visitor_id: this.visitor_id,
        zone: this.zone_id,
        category: this.category,
        voltage_level: this.voltage_level,
        contract_type: this.contract_type,
        type: this.mv
      };
      this.calculating = true;
      axios.post(this.host + '/calculate', this.obj).then((response) => {
        if (response.data.errors) {
          this.$toast.error('Нет исходных данных для расчета по ' + this.region_name + ' за ' + this.monthName + ' ' + this.year, {})
          console.log('НЕТ ДАННЫХ', response.data.errors);
        } else {
          router.push('result')

          this.calculating = false;
          this.result = true;
          this.results = response.data.result;

          this.vol.sum = response.data.sum;
          this.dkp = response.data.dkp;
          this.calculated = response.data;
          this.e6 = 4;
        }
      }).catch((er) => {
        console.log(er);
        this.$toast.error('Нет исходных данных для расчета по ' + this.region_name + ' за ' + this.monthName + ' ' + this.year, {})
      })
    },
    convert() {
      console.log('volumetext', this.vol.volume);

      let size = 24;
      let subarray = [];
      let array = [];
      this.vol.sum = 0;
      // this.vol.arr = [];
      array = this.vol.volume.split("\n");
      console.log('array', array.length);
      if (this.vol.volume.indexOf('\t') <= -1) {

        //alert('столбец');

        for (let i = 0; i < Math.ceil(array.length / size); i++) {
          subarray[i] = array.slice((i * size), (i * size) + size);
          // this.vol.arr[i] = [];

          for (let j = 0; j < subarray[i].length; j++) {
            if (this.vol.arr[i] && subarray[i][j]) {
              this.vol.arr[i][j] = parseFloat(subarray[i][j].replace(',', '.'));

              var obj = {
                value: parseFloat(subarray[i][j].replace(',', '.')),
                color: '#fff',
              }
              this.vol.sum = this.vol.sum + parseFloat(this.vol.arr[i][j]['value']);
              this.vol.arr[i][j] = obj;
            }
          }
          if (this.vol.arr[i]) {
            if (this.vol.arr[i].length != 24) {
              this.vol.arr.pop();
            }
          }

        }

        if (this.vol.arr.length < 28) {
          this.$toast.error('данные менее чем за 28 дней', {})
          this.vol.volume = '';
          // let msg = this.monthss[month - 1].label + ' сотоит из ' + this.days_count[month - 1] + " дней , ваша вставка содержит данные за  " + this.note.arr.length + ' день';
        } else {
          this.step1Ability = true;
        }

        if (this.vol.arr.length > 31) {
          this.$toast.error('данные более чем за 31 день', {})
          this.vol.volume = '';

          // let msg = this.monthss[month - 1].label + ' сотоит из ' + this.days_count[month - 1] + " дней , ваша вставка содержит данные за  " + this.note.arr.length + ' день';
        } else {
          this.step1Ability = true;

        }
      } else {


        alert('матрица');

        var arr = [];
        console.log('array', array);
        array.forEach((elem, index) => {
          //console.log('elem',elem);
          var arr_elem = elem.split('\t');
          //  console.log('arr_elem',arr_elem);
          arr[index] = arr_elem;
        })
        console.log('volarr2', this.vol.arr);
        for (var i = 0; i < this.vol.arr.length; i++) {
          for (var j = 0; j < this.vol.arr[i].length; j++) {
            if (arr[i][j]) {
              this.vol.arr[i][j]['value'] = parseFloat(arr[i][j].replace(',', '.'));
            }
          }
        }
      }
      this.sendToCheck();

      // console.log('paste volarr', this.vol.arr);

    },
    reload() {
      window.location.href = location['href'];//.reload();
    },
    toStep2(val) {
      this.e6 = 3;
      this.haveVolume = val;
    },
    getRegions() {
      axios.get(this.host + '/regions').then((response) => {
        this.regions = response.data;
      })
    },
    getDaysCount(year, month) {
      return new Date(year, month, 0).getDate();

    },
    getTemplate() {
      var dayscount = this.getDaysCount(this.year, this.month);
      var url = this.host + "/templates/xlsx/" + dayscount + ".xlsx";
      this.downloadURI(url, 'template');

    },
    downloadURI(uri, name) {
      var link = document.createElement("a");
      // If you don't know the name or want to use
      // the webserver default set name = ''
      link.setAttribute('download', name);
      link.href = uri;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    getZones() {
      axios.post(this.host + '/zones?region=' + this.region_id).then((response) => {
        this.zones = response.data;
        if (this.zones[0]) {
          this.zone_id = this.zones[0].value;
        }
      })
    },
    getAllZones() {
      axios.post(this.host + '/zones').then((response) => {
        this.zones = response.data;
        if (this.zones[0]) {
          this.zone_id = this.zones[0];
        }
      })
    },
    send() {

      var that = this;
      axios.post('https://api.ieplatform.ru/api/contact-form', this.contactForm)
          .then((response) => {

            this.$toast.success(response.data.value, {})
            this.cf = false;

          })
          .catch((error) => {
            console.log(error);
            that.$toast.error(error.response.data.error, {})

          });


    },

    onFileChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
      if (this.file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, {type: 'binary'});
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const predata = XLSX.utils.sheet_to_json(ws, {header: 1});
          var arr = [];
          arr = predata.splice(4);
          arr.forEach((elem) => {
            elem.shift();
          })
          this.step1Ability = true;
          this.vol.sum = 0;
          var sum = 0;
          for (let index = 0; index < this.vol.arr.length; index++) {
            for (let index1 = 0; index1 < this.vol.arr[index].length; index1++) {
              if (arr[index][index1]) {
                var obj = {
                  value: parseFloat(arr[index][index1]),
                  color: '#fff'
                }
                sum = sum + parseFloat(arr[index][index1]);
                this.vol.arr[index][index1] = obj;
              }
            }
          }
          this.vol.sum = sum;
          document.getElementById('ifile').value = null;
          this.sendToCheck();
          this.monthsTrim();
        }
        reader.readAsBinaryString(this.file);
      }
    },
    fileToJson(e) {
      const file = e.target.files[0]
      const reader = new FileReader()
      reader.onload = (e) => {
        const bstr = e.target.result
        const wb = XLSX.read(bstr, {type: 'binary'})
        const wsname = wb.SheetNames[0]
        const ws = wb.Sheets[wsname]
        const data = XLSX.utils.sheet_to_json(ws, {header: 1})
        console.log(data);
      }
      reader.readAsBinaryString(file)
    },
    volumeUpload() {
    }
  },
  computed: {
    selfDomain(){
      return 'https://calculator2b.etarif.ru/';
    },
    currentDay() {
      const date = new Date();

      let day = date.getDate();
      return day;
    },
    pricecesTarifsTitle() {
      var title = '';
      title = this.region_name + ', ' + this.zone_name + ', ' + this.voltage_name + ', ' + this.category_name + " за " + this.monthName + " " + this.year;
      return title;
    },
    startPicker() {
      var endDate = new Date(this.date.getFullYear(), this.date.getMonth() - 2, 10);
      return endDate.toISOString().slice(0, 7)
    },
    permanentDrawer() {
      return true;
    },
    drawersWidth() {
      if (this.isMobile) {
        return '100%';
      }
      return 340;
    },
    sum() {
      var sum = 0;
      var arr = [];
      for (let i = 0; i < this.vol.arr.length; i++) {
        var sarr = this.vol.arr[i];
        arr[i] = [];
        for (let j = 0; j < sarr.length; j++) {
          if (this.mv == 'kvt') {
            arr[i][j] = sarr[j];
          } else {
            arr[i][j] = sarr[j];
          }
          sum = sum + arr[i][j]['value'];
        }
      }
      return sum;
    },
    urlResult() {
      if (window.location.href.indexOf('result') > -1) {
        return true;
      }
      return false;
    },
    month() {
      return parseInt(this.picker.slice(5, 7));
    },
    /* eslint-disable */

    zone_name() {
      var zone_name = '';
      if (this.zone_id) {
        this.zones.forEach((zone) => {
          if (this.zone_id == zone.value) {
            zone_name = zone.label;
          }
        })
      }
      return zone_name;
    },
    region_name() {
      var region_name = '';
      if (this.region_id) {
        this.regions.forEach((region) => {
          if (this.region_id == region.value) {
            region_name = region.label;
          }
        })
      } else {
        region_name = "неизвестному региону";
      }
      return region_name;
    },
    category_name() {
      var category_name = '';
      if (this.category) {
        this.categories.forEach((cat) => {
          if (this.category == cat.value) {
            category_name = cat.label;
          }
        })
      }
      return category_name;
    },
    voltage_name() {
      var voltage_name = '';
      if (this.voltage_level) {
        this.voltage_levels.forEach((vol) => {
          if (this.voltage_level == vol.level) {
            voltage_name = vol.label;
          }
        })
      }
      return voltage_name;
    },
    getEndDate() {

      var endDate = new Date(this.date.getFullYear(), this.date.getMonth() - 1, 10);
      if (this.currentDay < 18) {
        var endDate = new Date(this.date.getFullYear(), this.date.getMonth() - 2, 10);
      }
      return endDate.toISOString().slice(0, 10)
    },

    year() {
      if (this.picker) {
        return this.picker.slice(0, 4);
      }
      return new Date().getFullYear();
    },
    monthName() {
      return this.months[this.month - 1].name;
    },
    host() {
      return process.env.VUE_APP_HOST;
    },
    step2ability() {
      if (this.zone_id) {
        return true;
      }
      return false;
    },

    disabled() {
      if (!this.zone_id) {
        return true;
      }
      return false;
    },
    know_label() {
      if (this.know) {
        return 'Я знаю свой почасовой объем потребления';
      } else {
        return "Я не знаю свой почасовой объем потребления"
      }
    },

    showStep2() {
      if (this.volume_file || this.consumption_type) {
        return true;
      }
      return false;
    },
    showStep3() {
      if (this.zone_id) {
        return true;
      }
      return false;
    },
    btnAbility() {
      if (this.zone_id) {
        return false;
      }
      return true;
    },
    years() {
      const currentYear = (new Date()).getFullYear();
      const range = (start, stop, step) => Array.from({length: (stop - start) / step + 1}, (_, i) => start + (i * step));
      return (range(currentYear, 2019, -1));
    },

  },
  mounted() {
    this.sendStatistic();
    this.year = this.years[1];
    this.picker = this.startPicker;
    this.generateEmpty();
    this.sendToCheck();
    //this.getAllZones();
    this.getRegions();
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() - 1;
  }

}
</script>
<style >
.iwidget .v-date-picker-table--month td {
  height: 24px !important;
}

.iwidget .v-btn:not(.v-btn--round).v-size--default {
  height: 24px !important;
}
.iwidget .v-date-picker-table {
  height: 112px !important;
}
.iwidget .iwidget .v-date-picker-table{
  height: 112px !important;

}
.v-picker__title {
  display: none !important;
}

.v-date-picker-table {
  height: 156px !important;
}

</style>

